// src/components/JobRequestModal/index.jsx
// Modal para solicitar especialista com deducao de creditos via escrow
import React, { useState, useEffect } from 'react';
import {
  BriefcaseIcon,
  CheckCircleIcon,
  BoltIcon,
  LockClosedIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import apiClient from '../../lib/apiClient';
import './styles.css';

const COST_MAP  = { refinement: 3, ads_setup: 10, ai_creation: 1 };
const TYPE_LABEL = { refinement: 'Refino Especialista', ads_setup: 'Setup Campanha Ads', ai_creation: 'Criação IA' };

export default function JobRequestModal({ type = 'refinement', campaignId, onClose, onSuccess }) {
  const [wallet, setWallet]   = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [done, setDone]       = useState(null);

  const cost = COST_MAP[type] ?? 3;

  useEffect(() => {
    const load = async () => {
      try {
        const r = await apiClient.request('/wallet/balance', { method: 'GET' });
        const d = await r.json();
        if (d.success) setWallet(d.wallet);
      } catch {}
    };
    load();
  }, []);

  const handleRequest = async () => {
    setError('');
    if (wallet && wallet.available_credits < cost) {
      setError(`Saldo insuficiente. Você tem ${wallet.available_credits} crédito(s), precisa de ${cost}.`);
      return;
    }
    setLoading(true);
    try {
      const r = await apiClient.request('/job/request', {
        method: 'POST',
        body: JSON.stringify({ type, campaign_id: campaignId }),
      });
      const d = await r.json();
      if (d.success) {
        setDone(d);
        onSuccess?.(d);
      } else {
        setError(d.message || 'Erro ao solicitar especialista');
      }
    } catch { setError('Erro de conexão'); }
    finally { setLoading(false); }
  };

  return (
    <div className="jrm-overlay" onClick={(e) => e.target === e.currentTarget && onClose?.()}>
      <div className="jrm-modal">
        <button className="jrm-close" onClick={onClose}><XMarkIcon style={{ width: 20, height: 20 }} /></button>

        {!done ? (
          <>
            <div className="jrm-icon"><BriefcaseIcon style={{ width: 40, height: 40 }} /></div>
            <h2 className="jrm-title">{TYPE_LABEL[type]}</h2>
            <p className="jrm-sub">Um especialista certificado irá revisar e otimizar seu anúncio.</p>

            <div className="jrm-cost-box">
              <div className="jrm-cost-row">
                <span>Custo</span>
                <span className="jrm-cost-val"><BoltIcon style={{ width: 13, height: 13, display: 'inline', marginRight: 2 }} />{cost} crédito{cost > 1 ? 's' : ''}</span>
              </div>
              <div className="jrm-cost-row">
                <span>Disponível</span>
                <span className={`jrm-cost-val ${wallet && wallet.available_credits >= cost ? 'jrm-ok' : 'jrm-low'}`}>
                  <BoltIcon style={{ width: 13, height: 13, display: 'inline', marginRight: 2 }} />{wallet?.available_credits ?? '…'}
                </span>
              </div>
              <div className="jrm-cost-row">
                <span>Prazo especialista aceitar</span>
                <span className="jrm-cost-val">30 min</span>
              </div>
              <div className="jrm-cost-row">
                <span>Prazo de entrega</span>
                <span className="jrm-cost-val">2 horas</span>
              </div>
            </div>

            <div className="jrm-escrow-note">
              <LockClosedIcon style={{ width: 14, height: 14, display: 'inline', marginRight: 4 }} />
              Créditos ficam bloqueados em <strong>escrow</strong> e só são liberados ao especialista
              após sua aprovação ou expiração do prazo de entrega.
            </div>

            {error && <div className="jrm-error">{error}</div>}

            <div className="jrm-actions">
              <button className="jrm-btn jrm-btn--cancel" onClick={onClose}>Cancelar</button>
              <button className="jrm-btn jrm-btn--confirm" onClick={handleRequest} disabled={loading}>
                {loading ? 'Solicitando…' : <><BoltIcon style={{ width: 13, height: 13, display: 'inline', marginRight: 3 }} />{`Solicitar por ${cost}`}</>}
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="jrm-icon"><CheckCircleIcon style={{ width: 40, height: 40, color: '#4ade80' }} /></div>
            <h2 className="jrm-title">Job criado!</h2>
            <p className="jrm-sub">Especialistas do nicho estão sendo notificados.</p>
            <div className="jrm-done-box">
              <div className="jrm-done-row"><span>Job ID</span><code>{done.job_id}</code></div>
              <div className="jrm-done-row"><span>Créditos bloqueados</span><span><BoltIcon style={{ width: 12, height: 12, display: 'inline', marginRight: 2 }} />{done.credits_locked}</span></div>
              <div className="jrm-done-row"><span>Aceitar até</span>
                <span>{new Date(done.deadline * 1000).toLocaleTimeString('pt-BR')}</span></div>
            </div>
            <button className="jrm-btn jrm-btn--confirm" onClick={onClose}>Fechar</button>
          </>
        )}
      </div>
    </div>
  );
}
